import { INTERNAL_SERVER_ERROR } from './errorConstants';

export const LOGIN_MSG = {
  MFA_SUCCESS: [
    {
      type: 'success',
      msg: 'loginPage_appMsg_success_MFA_active',
    },
    {
      type: 'info',
      msg: 'loginPage_appMsg_info_account_updated',
      fadeOut: 7000,
    },
  ],
  SIGN_OUT_SUCCESS: [
    {
      type: 'success',
      msg: 'componentProfileMenu_sign_out_msg',
    },
  ],
  SESSION_EXPIRED: [
    {
      type: 'info',
      msg: 'loginPage_appMsg_info_session_expired',
      fadeOut: 8000,
    },
  ],
  SUSPENDED_USER: [
    {
      type: 'error',
      msg: 'loginPage_appMsg_error_account_suspended',
      fadeOut: 8000,
    },
  ],
} as const;

export const PASSWORD_UPDATED_MSG = [
  {
    type: 'success',
    msg: 'accountPage_form_success_password_has_been_updated',
  },
] as const;

export const UPDATING_TEAM_MEMBER_ROLE_MSG = {
  type: 'info',
  msg: 'accountPage_form_in_process_team_member_role_updated',
};

export const UPDATED_TEAM_MEMBER_ROLE_SUCCESS_MSG = {
  type: 'success',
  msg: 'accountPage_form_success_team_member_role_updated',
} as const;

export const UPDATED_TEAM_MEMBER_ROLE_ERROR_MSG = {
  type: 'error',
  msg: 'accountPage_form_error_team_member_role_updated',
} as const;

export const EMAIL_IN_USE_MSG = [
  {
    type: 'error',
    msg: INTERNAL_SERVER_ERROR,
    fadeOut: 5000,
  },
  {
    type: 'info',
    msg: 'signupPage_form_error_email_in_use',
    fadeOut: 7000,
  },
] as const;

export const INTERNAL_SERVER_ERROR_MSG = [
  {
    type: 'error',
    msg: INTERNAL_SERVER_ERROR,
  },
] as const;
